import React from 'react';

interface HeaderPatternProps {
    theme?: string;
}

/* ── Padrões SVG ── cada um usa elementos menores e mais bem posicionados ── */

const PatternDefault: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        <circle cx="720" cy="-10" r="120" fill="rgba(255,255,255,0.07)" />
        <circle cx="760" cy="160" r="80" fill="rgba(255,255,255,0.05)" />
        <circle cx="60" cy="140" r="55" fill="rgba(255,255,255,0.04)" />
        <circle cx="400" cy="-20" r="60" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternChemistry: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Erlenmeyer flask */}
        <path d="M700 30 L693 65 L672 110 L728 110 L707 65 L700 30Z"
            fill="none" stroke="rgba(255,255,255,0.14)" strokeWidth="2" strokeLinejoin="round" />
        <ellipse cx="700" cy="111" rx="28" ry="9" fill="rgba(255,255,255,0.09)" />
        <line x1="693" y1="38" x2="707" y2="38" stroke="rgba(255,255,255,0.10)" strokeWidth="1.5" />
        {/* Hexagons */}
        <polygon points="90,55 104,47 118,55 118,71 104,79 90,71"
            fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" />
        <polygon points="118,71 132,63 146,71 146,87 132,95 118,87"
            fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <polygon points="62,71 76,63 90,71 90,87 76,95 62,87"
            fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        {/* Small bubbles */}
        <circle cx="660" cy="65" r="5" fill="rgba(255,255,255,0.09)" />
        <circle cx="740" cy="75" r="4" fill="rgba(255,255,255,0.07)" />
        <circle cx="650" cy="85" r="3" fill="rgba(255,255,255,0.06)" />
        <circle cx="400" cy="180" r="55" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternPhysics: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Atom — smaller, more centered to the right */}
        <ellipse cx="700" cy="90" rx="65" ry="26"
            fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" />
        <ellipse cx="700" cy="90" rx="65" ry="26"
            fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5"
            transform="rotate(60 700 90)" />
        <ellipse cx="700" cy="90" rx="65" ry="26"
            fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5"
            transform="rotate(120 700 90)" />
        <circle cx="700" cy="90" r="6" fill="rgba(255,255,255,0.18)" />
        <circle cx="765" cy="90" r="3" fill="rgba(255,255,255,0.14)" />
        {/* Wave */}
        <path d="M40 140 Q65 125 90 140 Q115 155 140 140 Q165 125 190 140 Q215 155 240 140 Q265 125 290 140"
            fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <path d="M40 160 Q65 145 90 160 Q115 175 140 160 Q165 145 190 160"
            fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        <circle cx="120" cy="50" r="40" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternMath: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Pi */}
        <path d="M660 50 L720 50 M675 50 L675 100 M705 50 L705 100"
            stroke="rgba(255,255,255,0.14)" strokeWidth="2.5" strokeLinecap="round" />
        {/* Integral */}
        <path d="M745 35 Q757 30 757 45 L757 100 Q757 115 769 110"
            fill="none" stroke="rgba(255,255,255,0.11)" strokeWidth="2" />
        {/* Grid */}
        <line x1="0" y1="60" x2="160" y2="60" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
        <line x1="0" y1="100" x2="160" y2="100" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
        <line x1="0" y1="140" x2="160" y2="140" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        <line x1="40" y1="0" x2="40" y2="200" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
        <line x1="80" y1="0" x2="80" y2="200" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
        <line x1="120" y1="0" x2="120" y2="200" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        {/* Triangle */}
        <polygon points="440,40 490,130 390,130"
            fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <circle cx="580" cy="-10" r="60" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternHistory: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Columns */}
        <rect x="670" y="55" width="12" height="115" fill="rgba(255,255,255,0.10)" rx="2" />
        <rect x="695" y="55" width="12" height="115" fill="rgba(255,255,255,0.10)" rx="2" />
        <rect x="720" y="55" width="12" height="115" fill="rgba(255,255,255,0.10)" rx="2" />
        <rect x="660" y="48" width="84" height="10" fill="rgba(255,255,255,0.12)" rx="2" />
        <path d="M670 55 Q701 28 732 55" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
        {/* Scroll */}
        <rect x="55" y="55" width="100" height="80" rx="6"
            fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
        <line x1="68" y1="76" x2="142" y2="76" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
        <line x1="68" y1="90" x2="142" y2="90" stroke="rgba(255,255,255,0.09)" strokeWidth="1" />
        <line x1="68" y1="104" x2="130" y2="104" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
        <line x1="68" y1="118" x2="136" y2="118" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <circle cx="400" cy="185" r="55" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternGeography: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Globe */}
        <circle cx="700" cy="95" r="65"
            fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" />
        <ellipse cx="700" cy="95" rx="32" ry="65"
            fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
        <line x1="635" y1="95" x2="765" y2="95" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <ellipse cx="700" cy="95" rx="65" ry="25"
            fill="none" stroke="rgba(255,255,255,0.06)" strokeWidth="1" />
        <ellipse cx="700" cy="95" rx="65" ry="48"
            fill="none" stroke="rgba(255,255,255,0.05)" strokeWidth="1" />
        {/* Mountains */}
        <path d="M60 165 L100 90 L140 165Z" fill="rgba(255,255,255,0.08)" />
        <path d="M120 165 L165 105 L210 165Z" fill="rgba(255,255,255,0.06)" />
        <circle cx="380" cy="-15" r="60" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternBiology: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* DNA double helix */}
        <path d="M660 20 Q680 50 700 80 Q720 110 740 140 Q720 170 700 170"
            fill="none" stroke="rgba(255,255,255,0.13)" strokeWidth="2" />
        <path d="M740 20 Q720 50 700 80 Q680 110 660 140 Q680 170 700 170"
            fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="2" />
        <line x1="670" y1="35" x2="730" y2="35" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="680" y1="65" x2="720" y2="65" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <line x1="668" y1="95" x2="732" y2="95" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="680" y1="125" x2="720" y2="125" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <line x1="668" y1="155" x2="732" y2="155" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        {/* Leaf */}
        <path d="M80 150 Q100 80 150 60 Q130 120 80 150Z"
            fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.10)" strokeWidth="1" />
        <path d="M80 150 Q95 110 140 95" fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <circle cx="400" cy="180" r="50" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternGeometry: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Geometric shapes */}
        <polygon points="680,30 740,140 620,140"
            fill="none" stroke="rgba(255,255,255,0.13)" strokeWidth="2" />
        <rect x="635" y="95" width="45" height="45" fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <circle cx="700" cy="95" r="22"
            fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        {/* Angle marks */}
        <path d="M620 140 L640 140 L640 120" fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="1.5" />
        {/* Compass arc */}
        <path d="M80 160 L80 80 L160 80" fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <path d="M80 80 Q110 80 110 110 Q110 140 80 140" fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <line x1="80" y1="80" x2="115" y2="45" stroke="rgba(255,255,255,0.08)" strokeWidth="1" strokeDasharray="4 3" />
        <circle cx="400" cy="-10" r="55" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternPortuguese: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Pen/quill */}
        <path d="M720 30 L680 100 L670 130 L695 115 L735 45Z"
            fill="rgba(255,255,255,0.09)" stroke="rgba(255,255,255,0.12)" strokeWidth="1" />
        <path d="M680 100 L670 130 L695 115Z" fill="rgba(255,255,255,0.14)" />
        <path d="M720 30 L700 50" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
        {/* Text lines */}
        <line x1="55" y1="70" x2="190" y2="70" stroke="rgba(255,255,255,0.10)" strokeWidth="1.5" />
        <line x1="55" y1="88" x2="190" y2="88" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="55" y1="106" x2="170" y2="106" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <line x1="55" y1="124" x2="180" y2="124" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        {/* Quote marks */}
        <text x="55" y="58" fontFamily="serif" fontSize="28" fill="rgba(255,255,255,0.12)">"</text>
        <text x="175" y="140" fontFamily="serif" fontSize="28" fill="rgba(255,255,255,0.09)">"</text>
        <circle cx="400" cy="185" r="50" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternEnglish: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Speech bubble */}
        <rect x="640" y="30" width="130" height="80" rx="12"
            fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.11)" strokeWidth="1.5" />
        <path d="M660 110 L655 130 L675 115Z" fill="rgba(255,255,255,0.09)" />
        <line x1="658" y1="54" x2="752" y2="54" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="658" y1="68" x2="752" y2="68" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <line x1="658" y1="82" x2="730" y2="82" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        {/* Flag stripes */}
        <line x1="55" y1="65" x2="180" y2="65" stroke="rgba(255,255,255,0.09)" strokeWidth="3" />
        <line x1="55" y1="78" x2="180" y2="78" stroke="rgba(255,255,255,0.06)" strokeWidth="3" />
        <line x1="55" y1="91" x2="180" y2="91" stroke="rgba(255,255,255,0.09)" strokeWidth="3" />
        <line x1="55" y1="104" x2="180" y2="104" stroke="rgba(255,255,255,0.06)" strokeWidth="3" />
        <line x1="55" y1="117" x2="180" y2="117" stroke="rgba(255,255,255,0.09)" strokeWidth="3" />
        <circle cx="400" cy="-10" r="55" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternSpanish: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* ¡ and ¿ exclamation */}
        <text x="660" y="120" fontFamily="serif" fontSize="90" fontWeight="bold" fill="rgba(255,255,255,0.08)">¡</text>
        <text x="715" y="80" fontFamily="serif" fontSize="60" fill="rgba(255,255,255,0.07)">¿</text>
        {/* Decorative arch */}
        <path d="M60 150 Q60 60 140 60 Q220 60 220 150"
            fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="1.5" />
        <line x1="60" y1="150" x2="220" y2="150" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <circle cx="140" cy="60" r="8" fill="rgba(255,255,255,0.08)" />
        <circle cx="400" cy="185" r="50" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternPhilosophy: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Thinking head silhouette */}
        <circle cx="700" cy="65" r="35" fill="rgba(255,255,255,0.07)" stroke="rgba(255,255,255,0.11)" strokeWidth="1.5" />
        <path d="M685 100 L685 140" stroke="rgba(255,255,255,0.09)" strokeWidth="2" />
        <path d="M685 140 L660 160 M685 140 L710 160" stroke="rgba(255,255,255,0.07)" strokeWidth="2" />
        {/* Thought bubbles */}
        <circle cx="740" cy="45" r="7" fill="rgba(255,255,255,0.07)" />
        <circle cx="755" cy="30" r="5" fill="rgba(255,255,255,0.06)" />
        <circle cx="766" cy="18" r="4" fill="rgba(255,255,255,0.05)" />
        {/* Yin-yang hint */}
        <circle cx="105" cy="95" r="45" fill="none" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <path d="M105 50 A22.5 22.5 0 0 1 105 95 A22.5 22.5 0 0 0 105 140 A45 45 0 0 1 105 50Z"
            fill="rgba(255,255,255,0.06)" />
        <circle cx="105" cy="72.5" r="8" fill="rgba(255,255,255,0.09)" />
        <circle cx="105" cy="117.5" r="8" fill="rgba(255,255,255,0.04)" />
        <circle cx="400" cy="-10" r="55" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternSociology: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Network of people nodes */}
        <circle cx="700" cy="70" r="10" fill="rgba(255,255,255,0.12)" />
        <circle cx="660" cy="110" r="10" fill="rgba(255,255,255,0.10)" />
        <circle cx="740" cy="110" r="10" fill="rgba(255,255,255,0.10)" />
        <circle cx="700" cy="150" r="10" fill="rgba(255,255,255,0.08)" />
        <circle cx="640" cy="60" r="7" fill="rgba(255,255,255,0.07)" />
        <circle cx="760" cy="60" r="7" fill="rgba(255,255,255,0.07)" />
        <line x1="700" y1="70" x2="660" y2="110" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="700" y1="70" x2="740" y2="110" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="660" y1="110" x2="700" y2="150" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        <line x1="740" y1="110" x2="700" y2="150" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        <line x1="700" y1="70" x2="640" y2="60" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <line x1="700" y1="70" x2="760" y2="60" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        {/* Buildings */}
        <rect x="55" y="90" width="30" height="80" fill="rgba(255,255,255,0.07)" rx="2" />
        <rect x="95" y="70" width="40" height="100" fill="rgba(255,255,255,0.08)" rx="2" />
        <rect x="145" y="100" width="28" height="70" fill="rgba(255,255,255,0.06)" rx="2" />
        <circle cx="400" cy="185" r="50" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternGrammar: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* S-V-O structure */}
        <text x="640" y="60" fontFamily="monospace" fontSize="14" fill="rgba(255,255,255,0.12)" fontWeight="bold">S</text>
        <text x="670" y="60" fontFamily="monospace" fontSize="14" fill="rgba(255,255,255,0.12)" fontWeight="bold">—</text>
        <text x="690" y="60" fontFamily="monospace" fontSize="14" fill="rgba(255,255,255,0.12)" fontWeight="bold">V</text>
        <text x="720" y="60" fontFamily="monospace" fontSize="14" fill="rgba(255,255,255,0.12)" fontWeight="bold">—</text>
        <text x="740" y="60" fontFamily="monospace" fontSize="14" fill="rgba(255,255,255,0.12)" fontWeight="bold">O</text>
        {/* Brackets */}
        <path d="M645 80 L635 80 L635 150 L645 150" fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="2" />
        <path d="M755 80 L765 80 L765 150 L755 150" fill="none" stroke="rgba(255,255,255,0.10)" strokeWidth="2" />
        {/* Text lines */}
        <line x1="55" y1="65" x2="200" y2="65" stroke="rgba(255,255,255,0.09)" strokeWidth="1.5" />
        <line x1="55" y1="82" x2="200" y2="82" stroke="rgba(255,255,255,0.08)" strokeWidth="1.5" />
        <line x1="55" y1="99" x2="175" y2="99" stroke="rgba(255,255,255,0.07)" strokeWidth="1.5" />
        <line x1="55" y1="116" x2="190" y2="116" stroke="rgba(255,255,255,0.06)" strokeWidth="1.5" />
        {/* Underline decoration */}
        <line x1="55" y1="68" x2="100" y2="68" stroke="rgba(255,255,255,0.12)" strokeWidth="2" />
        <circle cx="400" cy="-10" r="55" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PatternLiterature: React.FC = () => (
    <svg width="100%" height="100%" viewBox="0 0 800 200"
        preserveAspectRatio="xMidYMid slice"
        style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}
        xmlns="http://www.w3.org/2000/svg">
        {/* Open book */}
        <path d="M650 50 L700 45 L750 50 L750 155 L700 150 L650 155 L650 50Z"
            fill="rgba(255,255,255,0.05)" stroke="rgba(255,255,255,0.11)" strokeWidth="1.5" />
        <line x1="700" y1="45" x2="700" y2="150" stroke="rgba(255,255,255,0.12)" strokeWidth="2" />
        <line x1="660" y1="75" x2="698" y2="75" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
        <line x1="660" y1="89" x2="698" y2="89" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <line x1="660" y1="103" x2="698" y2="103" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <line x1="702" y1="75" x2="740" y2="75" stroke="rgba(255,255,255,0.08)" strokeWidth="1" />
        <line x1="702" y1="89" x2="740" y2="89" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <line x1="702" y1="103" x2="740" y2="103" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        {/* Feather */}
        <path d="M130 40 Q90 80 75 150"
            fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="2" />
        <path d="M130 40 Q160 90 75 150" fill="rgba(255,255,255,0.07)" />
        <path d="M110 68 Q95 90 85 115" fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth="1" />
        <circle cx="400" cy="185" r="50" fill="rgba(255,255,255,0.03)" />
    </svg>
);

const PATTERNS: Record<string, React.FC> = {
    default:    PatternDefault,
    chemistry:  PatternChemistry,
    physics:    PatternPhysics,
    math:       PatternMath,
    history:    PatternHistory,
    geography:  PatternGeography,
    biology:    PatternBiology,
    geometry:   PatternGeometry,
    portuguese: PatternPortuguese,
    english:    PatternEnglish,
    spanish:    PatternSpanish,
    philosophy: PatternPhilosophy,
    sociology:  PatternSociology,
    grammar:    PatternGrammar,
    literature: PatternLiterature,
};

const HeaderPattern: React.FC<HeaderPatternProps> = ({ theme = 'default' }) => {
    const Pattern = PATTERNS[theme] ?? PatternDefault;
    return <Pattern />;
};

export const HEADER_THEMES = [
    { id: 'default',    label: 'Padrão',      emoji: '◯' },
    { id: 'chemistry',  label: 'Química',      emoji: '⚗️' },
    { id: 'physics',    label: 'Física',       emoji: '⚛️' },
    { id: 'math',       label: 'Matemática',   emoji: 'π' },
    { id: 'history',    label: 'História',     emoji: '🏛️' },
    { id: 'geography',  label: 'Geografia',    emoji: '🌎' },
    { id: 'biology',    label: 'Biologia',     emoji: '🧬' },
    { id: 'geometry',   label: 'Geometria',    emoji: '📐' },
    { id: 'portuguese', label: 'Português',    emoji: '✍️' },
    { id: 'english',    label: 'Inglês',       emoji: '🇬🇧' },
    { id: 'spanish',    label: 'Espanhol',     emoji: '🇪🇸' },
    { id: 'philosophy', label: 'Filosofia',    emoji: '🤔' },
    { id: 'sociology',  label: 'Sociologia',   emoji: '👥' },
    { id: 'grammar',    label: 'Gramática',    emoji: '📝' },
    { id: 'literature', label: 'Literatura',   emoji: '📖' },
];

export default HeaderPattern;
